import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-app-role-usecase-list',
  templateUrl: './app-role-usecase-list.component.html',
  styleUrls: ['./app-role-usecase-list.component.scss'],
})
export class AppRoleUsecaseListComponent extends BaseListCtl {
  public appId: number = 0;

  permissions: string[] = ['Yes', 'No'];
  types: string[] = ['form', 'usecase'];
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(
      locator.config.get('endpoint.application.role.usecase'),
      locator,
      route
    );
    let _self = this;
    locator.getPathVariable(route, function (params: any) {
      _self.appId = params['appId'];
    });
    _self.form['applicationId'] = 0;
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
    form.applicationRoleId = data.applicationRoleId;
    form.applicationRoleName = data.applicationName;
    form.userstoryId = data.userstoryId;
    form.userstoryName = data.userstoryName;
    //form.type = data.type;
    form.create = data.create | 1;
    form.update = data.update | 1;
    form.read = data.read | 1;
    form.delete = data.delete | 1;
  }
  override ngOnInit() {
    this.preload();
    this.search();
    this.getApplications();
  }

  /**
  * Contains applications
  */
  public applications: any = [];

  getApplications() {
    let _self = this;
    // get applications 
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  public applicationsroles: any = [];

  getApplicationRole() {
    let _self = this;
    // get applications 
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/application-roles/' +
      _self.form.data['applicationId'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationsroles = res.result.data;

      _self.form.applicationRoleId = _self.form.data.applicationRoleId;
    });
  }

  public userstorys: any = [];
  public forms: any = [];

  getUsecaseOrForm(): void {
    let _self = this;

    if (_self.form.data['type'] === 'form') {
      return _self.getForms();
    } else {
      return _self.getUsecases();
    }
  }

  getUsecases() {
    let _self = this;
    // get applications 
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/usecases/' +
      _self.form.data['applicationId'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.userstorys = res.result.data;
    });
  }

  getForms() {
    let _self = this;
    // get applications 

    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/forms/' +
      _self.form.data['applicationId'];

    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.forms = res.result.data;
    });
  }

  public editAppRoleUsecase(id: number) {
    let _self = this;
    super.get(id, function cb() {
      //_self.getApplications();
      _self.getApplicationRole();
      _self.getUsecaseOrForm();
    });
  }
}
